// extracted by mini-css-extract-plugin
export default {"fallbackContentImageSlider":"styles_fallback-content-image-slider__C69xO"};